module.exports = __webpack_public_path__ + "img/shipo-map-time.0caceb89.svg";